import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { sendMetriks } from "Services/sendMetriks";
import { pipe } from "Utils/functionalUtils";
import { LimitPlansBTableContainer } from "Constants/Limit";
import PlanBRowContainer from "Containers/PlanBRowContainer";
import { TariffsTable, TariffsHeaderRow } from "ComponentsUI/TarifficationB";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";

const PlansBTableContainer = (props) => {
    // Сколько элементов выводить на странице
    // const LIMIT = 30;

    let {
        ApplicationModel: { windowSizeModel, text },
        pagination,
    } = props;
    let connectTariffButton =
        props.ApplicationModel?.siteConfig?.settings
            ?.connect_tariff_button?.[props.pageName] || "connect";

    useEffect(() => {
        if (windowSizeModel.windowSizes.height && connectTariffButton === "connect" && !!props.tariffs?.length && props.tariffs.find(tariff => tariff?.provider?.provider_settings?.tariffs?.value === "button_text")) {
            sendMetriks("OPEN_NEW_TEXT");
        }
    }, [props.tariffs, windowSizeModel.windowSizes.height]);

    let generateTariffs = () => {
        return props.tariffs.map(item => {
            return (
                <PlanBRowContainer
                    key={item.id}
                    data={item}
                    providerInfo={item.provider}
                    showName={props.showNames}
                    compareIsHideInConnectTariffs={
                        props.compareIsHideInConnectTariffs
                    }
                    orderToHomeCompareBtnHidden={
                        props.orderToHomeCompareBtnHidden
                    }
                    compareIsHide={props.compareIsHide}
                    isCardPage={props.isCardPage}
                    isOrderToHome={props.isOrderToHome}
                    isTS={props.isTS}
                    isExclusives={props.isExclusives}
                    isAboutProvider={props.isAboutProvider}
                    isActions={props.isActions}
                    isRates={props.isRates}
                    isProviderRatesTags={props.isProviderRatesTags}
                    isCard={props.isCard}
                    isMainPage={props.isMainPage}
                    is404={props.is404}
                    isReviewsProviders={props.isReviewsProviders}
                    pageName={props.pageName}
                    microMarkupProduct={props.microMarkupProduct}
                    update_date={props.update_date}
                    noShowExlusive={props.noShowExlusive}
                />
            );
        });
    };

    let tableHeader = (
        <TariffsHeaderRow texts={text} showName={props.showNames} />
    );

    let pageTotal = 0;
    let page = 1;
    if (pagination) {
        pageTotal = Math.ceil(pagination.items_total / LimitPlansBTableContainer);
        if (props.match.params.page) {
            page = +props.match.params.page;
        }
    }

    return (
        <>
            <TariffsTable
                datatest={props.datatest}
                tableHeader={tableHeader}
            >
                {generateTariffs()}
            </TariffsTable>
            {pagination && (
                <div style={{ paddingTop: "15px" }}>
                    <Paginator
                        key={23}
                        itemsTotal={pagination.items_total}
                        itemsPerPage={LimitPlansBTableContainer}
                        pageCurrent={page}
                        pageTotal={pageTotal}
                        windowSizes={windowSizeModel.windowSizes}
                        urlDefault={props.urlDefault}
                        wrapperItem={<PaginatorElem />}
                        location={props.location}
                        datatest="tariffs"
                    />
                </div>
            )}
        </>
    );
};

export default pipe(
    observer,
    inject("ApplicationModel"),
    withRouter,
)(PlansBTableContainer);